import { Button, Spin, Typography } from "antd";
import { CvConfigDto, getConfigApplication } from "api/generated";
import { handleAxiosError } from "common/helpers/generalUtils";
import { useClient } from "hooks/useClient";
import { useEffect, useState } from "react";
import AppConfigurationScreen from "routes/configurationApplication/AppConfigurationScreen";
import { returnToRegister } from "security";

function FirstAppConfigurationWrapper() {
  const { client } = useClient();
  const [isLoading, setIsLoading] = useState(false);
  const [isConfigured, setIsConfigured] = useState(false);

  // Función para verificar si todas las configuraciones requeridas tienen valor
  function checkRequiredConfigs(nodes: CvConfigDto[]): boolean {
    let allRequiredHaveValue = true;

    const traverse = (node: CvConfigDto) => {
      // Si es un CONFIG y es requerido, verificar que tenga valor
      if (node.type === "CONFIG" && node.isRequired) {
        if (!node.value) {
          allRequiredHaveValue = false;
        }
      }
      // Recorrer hijos si existen
      if (node.children) {
        node.children.forEach(traverse);
      }
    };

    nodes.forEach(traverse);
    return allRequiredHaveValue;
  }

  function loadConfigs() {
    setIsLoading(true);
    getConfigApplication({ client })
      .then(({ data }) => {
        setIsConfigured(checkRequiredConfigs(data ?? []));
      })
      .catch((err) =>
        handleAxiosError(err, "No fue posible obtener las configuraciones"),
      )
      .finally(() => setIsLoading(false));
  }

  useEffect(() => {
    loadConfigs();
  }, [client]);

  function handleContinue() {
    returnToRegister();
  }

  return (
    <Spin spinning={isLoading}>
      <div style={{ position: "relative", minHeight: "500px" }}>
        <AppConfigurationScreen
          commitChange={() => {
            loadConfigs();
          }}
        />

        {/* Footer fijo */}
        <div
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1000,
            backgroundColor: "#ececec",
            borderTop: "1px solid #e5e7eb",
            padding: "12px 24px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 8,
            boxShadow: "0 -4px 16px rgba(0,0,0,0.08)",
          }}
        >
          {!isConfigured && (
            <Typography.Text style={{ textAlign: "center" }}>
              ⚠️ Completa todos los campos requeridos para continuar
            </Typography.Text>
          )}
          <Button
            type="primary"
            size="large"
            disabled={!isConfigured}
            onClick={handleContinue}
            style={{
              width: "100%",
              maxWidth: 480,
              height: 48,
              borderRadius: 8,
            }}
          >
            Continuar, ir a configurar la compañia
          </Button>
        </div>

        {/* Espaciado para que el contenido no quede tapado por el footer */}
        <div style={{ height: 100 }} />
      </div>
    </Spin>
  );
}

export default FirstAppConfigurationWrapper;
